/* HorseHalo "The Missing Layer" – replaces the Replo runtime for sliders, accordions,
   scroll links, video cards and add-to-cart. Safe to load once per section (guarded). */
(function () {
  if (window.__mlLanding) return;
  window.__mlLanding = true;

  function bp() {
    var w = window.innerWidth;
    return w <= 640 ? 2 : w <= 1024 ? 1 : 0; // 0 desktop, 1 tablet, 2 mobile
  }

  /* ---------- links / scroll-to-anchor ---------- */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-ml-href]');
    if (!el) return;
    var href = el.getAttribute('data-ml-href');
    if (!href) return;
    e.preventDefault();
    if (href.charAt(0) === '#') {
      var t = document.getElementById(href.slice(1));
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.location.href = href;
    }
  });

  /* ---------- accordions ---------- */
  function setOpen(c, open) {
    var hdr = c.querySelector(':scope > [role=button]');
    var body = c.querySelector(':scope > [id]:not([role=button])');
    var oc = hdr && hdr.getAttribute('data-ml-open-class');
    c.setAttribute('data-state', open ? 'open' : 'closed');
    if (hdr) {
      hdr.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (oc) hdr.classList.toggle(oc, open);
    }
    if (body) {
      if (open) body.removeAttribute('hidden');
      else body.setAttribute('hidden', '');
    }
  }
  document.addEventListener('click', function (e) {
    var hdr = e.target.closest('[data-ml-collapsible] > [role=button]');
    if (!hdr) return;
    var c = hdr.parentElement;
    setOpen(c, c.getAttribute('data-state') !== 'open');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var hdr = e.target.closest && e.target.closest('[data-ml-collapsible] > [role=button]');
    if (!hdr) return;
    e.preventDefault();
    hdr.click();
  });

  /* ---------- video cards (click to play / pause) ---------- */
  document.addEventListener('click', function (e) {
    var slide = e.target.closest('[data-ml-carousel] [data-ml-slide]');
    if (!slide) return;
    var v = slide.querySelector('video');
    if (!v || v.autoplay) return;
    var icon = slide.querySelector('[aria-label=Play]');
    var overlay = icon && icon.parentElement && icon.parentElement.parentElement;
    if (v.paused) {
      document.querySelectorAll('[data-ml-carousel] video').forEach(function (o) {
        if (o !== v && !o.paused) { o.pause(); var s = o.closest('[data-ml-slide]'); var i = s && s.querySelector('[aria-label=Play]'); if (i) i.parentElement.parentElement.style.visibility = ''; }
      });
      v.muted = false;
      v.play();
      if (overlay) overlay.style.visibility = 'hidden';
    } else {
      v.pause();
      if (overlay) overlay.style.visibility = '';
    }
  });

  /* ---------- carousels ---------- */
  function Carousel(root) {
    this.root = root;
    this.cfg = JSON.parse(root.getAttribute('data-ml-carousel'));
    this.track = root.querySelector('[data-replo-part=slide-track]');
    this.viewport = root.querySelector('[data-replo-part=slides]');
    this.slides = Array.prototype.slice.call(this.track.querySelectorAll(':scope > [data-ml-slide]'));
    this.n = this.slides.length;
    this.dotsWrap = root.querySelector('[data-ml-dot-active]');
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-ml-dot]'));
    this.sr = root.querySelector('[data-ml-sr]');
    this.index = 0;
    this.pos = 0;
    if (!this.n) return;
    if (this.cfg.fade) root.setAttribute('data-ml-fade', '');
    if (this.cfg.loop && !this.cfg.fade && this.n > 1) {
      // one set of clones on each side for seamless looping
      var self = this;
      this.slides.forEach(function (s) { var c = s.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.removeAttribute('data-shopify-editor-block'); c.setAttribute('data-ml-clone', ''); self.track.appendChild(c); });
      this.slides.slice().reverse().forEach(function (s) { var c = s.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.removeAttribute('data-shopify-editor-block'); c.setAttribute('data-ml-clone', ''); self.track.insertBefore(c, self.track.firstChild); });
      this.pos = this.n;
    }
    this.all = Array.prototype.slice.call(this.track.children);
    this.bind();
    this.layout();
  }
  Carousel.prototype.layout = function () {
    var b = bp();
    var pv = this.cfg.perView[b];
    var auto = this.cfg.autoWidth[b];
    this.track.style.setProperty('--replo-carousel-slides-per-page', pv);
    if (auto) this.root.setAttribute('data-ml-auto', ''); else this.root.removeAttribute('data-ml-auto');
    this.go(this.index, false);
  };
  Carousel.prototype.offsetOf = function (i) {
    var el = this.all[i];
    return el ? el.offsetLeft - this.all[0].offsetLeft : 0;
  };
  Carousel.prototype.setTransform = function (animate) {
    this.track.style.transition = animate ? 'transform 300ms ease' : 'none';
    this.track.style.transform = 'translate3d(' + (-this.offsetOf(this.pos)) + 'px, 0, 0)';
  };
  Carousel.prototype.go = function (i, animate) {
    var n = this.n;
    var self = this;
    if (this.cfg.fade) {
      this.index = ((i % n) + n) % n;
      this.slides.forEach(function (s, k) {
        s.classList.toggle('ml-active', k === self.index);
        s.style.left = k === 0 ? '0px' : 'calc(' + (-k) + ' * (100% + var(--replo-gap, 0px)))';
      });
    } else if (this.cfg.loop && n > 1) {
      var target = this.pos + (i - this.index);
      this.index = ((i % n) + n) % n;
      this.pos = target;
      this.setTransform(animate);
      clearTimeout(this._t);
      this._t = setTimeout(function () {
        if (self.pos >= 2 * n || self.pos < n) { self.pos = n + self.index; self.setTransform(false); }
      }, animate ? 320 : 0);
    } else {
      this.index = Math.max(0, Math.min(i, n - 1));
      this.pos = this.index;
      this.setTransform(animate);
    }
    var active = this.dotsWrap && this.dotsWrap.getAttribute('data-ml-dot-active');
    this.dots.forEach(function (d, k) {
      if (active) d.classList.toggle(active, k === self.index);
      d.setAttribute('aria-current', k === self.index ? 'true' : 'false');
    });
    if (this.sr) this.sr.textContent = 'Slide ' + (this.index + 1) + ' of ' + n;
  };
  Carousel.prototype.bind = function () {
    var self = this;
    this.root.querySelectorAll('[data-replo-part=nav-button]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        self.go(self.index + (b.getAttribute('data-direction') === 'next' ? 1 : -1), true);
      });
    });
    this.dots.forEach(function (d, k) {
      d.addEventListener('click', function () { self.go(k, true); });
    });
    var x0 = null, y0 = null;
    this.viewport.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    this.viewport.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) self.go(self.index + (dx < 0 ? 1 : -1), true);
      x0 = null;
    });
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { self.layout(); }, 100); });
  };

  function initCarousels(scope) {
    (scope || document).querySelectorAll('[data-ml-carousel]').forEach(function (r) {
      if (r.__ml) return;
      r.__ml = new Carousel(r);
    });
  }

  /* ---------- add to cart (same flow as the Replo button) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ml-atc]');
    if (!btn) return;
    var form = document.getElementById(btn.getAttribute('form'));
    if (!form) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: {}, sections: ['cart-drawer', 'cart-icon-bubble'] })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (cartData) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && drawer.renderContents) drawer.renderContents(cartData);
        var d2 = document.querySelector('cart-drawer.drawer');
        if (d2) d2.classList.remove('is-empty');
        document.dispatchEvent(new CustomEvent('ml:added-to-cart', { detail: cartData }));
      })
      .catch(function (err) { console.error('[ml-landing] add to cart failed', err); })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  });

  /* ---------- theme compatibility ----------
     Several theme scripts (hero trust row, vet badge, Intelligems review card, cart tweaks)
     look for the old Replo wrapper #replo-fullpage-element. On the live storefront we group
     this page's sections under a wrapper with that id so they keep working unchanged.
     Skipped inside the theme editor so section editing is never affected. */
  function reploCompat() {
    if (window.Shopify && Shopify.designMode) return;
    if (!document.querySelector('meta[name="ml-replo-compat"]')) return;
    if (document.getElementById('replo-fullpage-element')) return;
    var secs = [];
    document.querySelectorAll('.ml-section').forEach(function (s) {
      var sec = s.closest('.shopify-section') || s;
      if (secs.indexOf(sec) === -1) secs.push(sec);
    });
    if (!secs.length) return;
    var wrap = document.createElement('div');
    wrap.id = 'replo-fullpage-element';
    wrap.className = 'ml-replo-root';
    secs[0].parentNode.insertBefore(wrap, secs[0]);
    secs.forEach(function (s) { wrap.appendChild(s); });
    // moving a <video> pauses it; resume the autoplaying ones
    wrap.querySelectorAll('video[autoplay]').forEach(function (v) {
      if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  }

  function init(scope) { if (!scope) reploCompat(); initCarousels(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  window.addEventListener('load', function () {
    document.querySelectorAll('[data-ml-carousel]').forEach(function (r) { if (r.__ml && r.__ml.layout) r.__ml.layout(); });
  });
  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
